import { GtmEvents } from '@/gtm/gtm-events';

export class TypGtmEvents extends GtmEvents {
  constructor() {
    super('СобытияСпасибоЗаПокупку');
  }

  payOnline({ orderNumber }) {
    return this.gtmEvent({
      eventAction: 'TYP_ОплатитьОнлайн',
      eventLabel: orderNumber,
    });
  }

  payFps({ orderNumber }) {
    return this.gtmEvent({
      eventAction: 'TYP_ОплатитьСБП',
      eventLabel: orderNumber,
    });
  }

  paidOnline({ orderNumber }) {
    return this.gtmEvent({
      eventAction: 'TYP_ЗаказОплаченОнлайн',
      eventLabel: orderNumber,
    });
  }

  paidFps({ orderNumber }) {
    return this.gtmEvent({
      eventAction: 'TYP_ЗаказОплаченСБП',
      eventLabel: orderNumber,
    });
  }

  pageVisible(orderNumber) {
    return this.gtmEvent({
      eventAction: 'TYP_ПросмотрСтраницы',
      eventLabel: orderNumber,
    });
  }

  orderInfoCollapse(isOpen) {
    if (isOpen) {
      return this.gtmEvent({
        eventAction: 'TYP_РазвернутьИнфо',
      });
    }
    return this.gtmEvent({
      eventAction: 'TYP_СвернутьИнфо',
    });
  }

  productCardClick(productId) {
    return this.gtmEvent({
      eventAction: 'TYP_Товар_Клик',
      eventLabel: productId,
    });
  }

  orderPrintClick(orderNumber) {
    return this.gtmEvent({
      eventAction: 'TYP_Заказ_Печать',
      eventLabel: orderNumber,
    });
  }
}

export const typGtmEvents = new TypGtmEvents();
